import { h } from 'vue'
import OrganismPlayerVideo from '~/components/organisms/player-video/player-video.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentImage from '~ui/components/image/image.vue'

const Functional = (props) => {
  return h(
    UiComponentContainer,
    {
      class: 'image-or-video-full',
      end: 1,
      start: 1,
    },
    () => [
      h(UiComponentHeading, { level: 3 }, () => [props.record.title]),
      !props.record.asset.video
      && h(UiComponentImage, {
        alt: props.record.asset.alt,
        class: 'asset image',
        expectedSize: props.assetFullWidth,
        height: props.record.asset.height,
        source: props.record.asset.url,
        width: props.record.asset.width,
      }),
      props.record.asset.video
      && h(OrganismPlayerVideo, {
        autoPlay: false,
        class: 'asset video',
        posterSrc: props.record.asset.video.thumbnailUrl,
        videoSrc: props.record.asset.video.streamingUrl,
      }),
    ],
  )
}

Functional.props = {
  assetFullWidth: {
    required: true,
    type: Number,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
